if (!customElements.get("apply-discount-code")) {
  customElements.define(
    "apply-discount-code",
    class ApplyDiscountCode extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('[data-input-code]'),
          applyButton: this.querySelector('[data-apply-button]'),
          hintCode: this.querySelector('[data-hint-code]'),
        }
        this.cartItems = document.querySelectorAll('cart-items');

        this.initEvent();
      }

      initEvent() {
        this.elements.applyButton.addEventListener('click', () => {
          if (this.elements.input.value.trim() === '') {
            for (const component of this.components) {
              component.elements.input.value = '';
            }
            this.elements.input.focus(); // Focus on the input field
            this.elements.input.setCustomValidity(''); // Reset any previous custom validity message
            this.elements.input.reportValidity(); // Trigger the browser's validation message
          } else {
            this.submit(this.elements.input.value);
          }
        });
        this.elements.input.addEventListener('input', () => {
          if (this.classList.contains('loading')) return false;
          const value = this.elements.input.value;
          for (const component of this.components) {
            if (component != this) component.elements.input.value = value;
            component.classList.remove('failed');
            component.elements.applyButton.classList.remove('failed');
            component.elements.hintCode.innerHTML = this.elements.input.value;
          }
        });
        this.elements.input.addEventListener('keydown', (e) => {
          if (e.keyCode === 13) {
            this.elements.applyButton.click();
          }
        });
      }

      async submit(code) {
        this.startLoading();
        const redirect = encodeURIComponent(`${Shopify.routes.root}cart`);
        return originFetch(`${Shopify.routes.root}discount/${code}?redirect=${redirect}`).then((res) => {
          return res.text();
        }).then(async (res) => {
          const html = new DOMParser().parseFromString(res, 'text/html');
          const discountElement = html.querySelector('apply-discount-code');
          const discounts = discountElement.getAttribute('data-discounts').split(",").map((v) => v.trim().toLowerCase());
          console.log("discounts", discounts, "code", code);
          const codeLowerCase = code.toLowerCase();
          if (discounts.includes(codeLowerCase)) {
            // 折扣码有效
            publish(PUB_SUB_EVENTS.cartReload);
            this.notifySuccess();
            for (const component of this.components) {
              component.elements.input.value = '';
            }
          } else {
            // 折扣码无效
            publish(PUB_SUB_EVENTS.cartReload);
            this.notifyFailed();
          }
        }).finally(() => {
          this.finishLoading();
        });
      }

      get components() {
        return document.querySelectorAll('apply-discount-code');
      }

      /** 应用成功通知 */
      notifySuccess() {
        for (const component of this.components) {
          component.classList.remove('failed');
          component.elements.applyButton.classList.remove('failed');
          component.classList.add('success');
          component.elements.applyButton.classList.add('success');
        }
        setTimeout(() => {
          for (const component of this.components) {
            component.classList.remove('success');
            component.elements.applyButton.classList.remove('success');
          }
        }, 3000);
      }

      /** 应用失败通知 */
      notifyFailed() {
        for (const component of this.components) {
          component.classList.add('failed');
          component.elements.applyButton.classList.add('failed');
        }
      }

      startLoading() {
        this.cartItems.forEach((items) => items.enableLoading());
        for (const component of this.components) {
          component.classList.add('loading');
          component.elements.input.setAttribute('disabled', '');
          component.elements.applyButton.classList.add('loading');
        }
      }

      finishLoading() {
        this.cartItems.forEach((items) => items.disableLoading());
        for (const component of this.components) {
          component.classList.remove('loading');
          component.elements.input.removeAttribute('disabled');
          component.elements.applyButton.classList.remove('loading');
        }
      }
    }
  );
}
